export default __webpack_public_path__ + "static/media/mega.06691e92.svg";